import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { userInitState } from './state';
import { BlackListGrade } from 'src/admin-entity/enum/user/black-list-grade.enum';
import { AppState } from 'src/store';
import { BASE_URL } from 'src/config/api';
import client from 'src/api/client';
import { ExcelDownloadSummary } from 'src/admin-entity/interface/excel/excel-download-summary.interface';

export const searchBlackList = createAsyncThunk(
    `userSlice/searchBlackList`,
    async (_, { getState, rejectWithValue }) => {
        try {
            const { searchToken, searchString, blacklistGrade, isAppUser, page, take } = (getState() as AppState).user
                .blackListSearchCondition;

            const url = new URL(`${BASE_URL}/v1/admin/app-user-blacklist`);

            if (searchString) {
                url.searchParams.append(searchToken, searchString);
            }
            if (blacklistGrade !== 'all') {
                url.searchParams.append('blacklistGrade', `${blacklistGrade}`);
            }
            if (isAppUser !== 'all') {
                url.searchParams.append('isAppUser', `${isAppUser}`);
            }
            url.searchParams.append('page', `${page}`);
            url.searchParams.append('page', `${take}`);
            const res = await client.get<any>(url.toString());
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

export const getBlackListExcel = createAsyncThunk(
    `userSlice/getBlackListExcel`,
    async (_, { getState, rejectWithValue }) => {
        try {
            const { searchToken, searchString, blacklistGrade, isAppUser, page, take } = (getState() as AppState).user
                .blackListSearchCondition;

            const url = new URL(`${BASE_URL}/v1/admin/app-user-blacklist/excel`);
            if (searchString) {
                url.searchParams.append(searchToken, searchString);
            }
            if (blacklistGrade !== 'all') {
                url.searchParams.append('blacklistGrade', `${blacklistGrade}`);
            }
            if (isAppUser !== 'all') {
                url.searchParams.append('isAppUser', `${isAppUser}`);
            }
            url.searchParams.append('page', `${page}`);
            url.searchParams.append('page', `${take}`);
            const res = await client.post<ExcelDownloadSummary>(url.toString());
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

export const userSlice = createSlice({
    name: 'userSlice',
    initialState: userInitState,
    reducers: {
        initBlackListSearchCondition: state => {
            state.blackListSearchCondition = userInitState.blackListSearchCondition;
        },
        updateSearchToken: (state, action: PayloadAction<string>) => {
            state.blackListSearchCondition.searchToken = action.payload;
        },
        updateSearchString: (state, action: PayloadAction<string>) => {
            state.blackListSearchCondition.searchString = action.payload;
        },
        updateSearchPage: (state, action: PayloadAction<number>) => {
            state.blackListSearchCondition.page = action.payload;
        },
        updateSearchTake: (state, action: PayloadAction<number>) => {
            state.blackListSearchCondition.take = action.payload;
        },
        updateSearchIsAppUser: (state, action: PayloadAction<string>) => {
            state.blackListSearchCondition.isAppUser = action.payload;
        },
        updateSearchBlacklistGrade: (state, action: PayloadAction<'all' | BlackListGrade>) => {
            state.blackListSearchCondition.blacklistGrade = action.payload;
        },
        // 이 프로젝트(admin)에서는 닉네임 변경 기능을 사용하지 않아 더미로만 존재함
        updateNickname: (_state, _action: PayloadAction<string>) => {},
    },
    extraReducers: builder => {
        builder.addCase(searchBlackList.fulfilled, (state, { payload }) => {
            state.blackList = payload;
        });
        builder.addCase(getBlackListExcel.fulfilled, (state, { payload }) => {
            //
        });
    },
});

export const {
    initBlackListSearchCondition,
    updateSearchPage,
    updateSearchString,
    updateSearchTake,
    updateSearchToken,
    updateSearchBlacklistGrade,
    updateSearchIsAppUser,
    updateNickname,
} = userSlice.actions;
export default userSlice.reducer;
